import React from 'react';
import { Link } from 'react-router-dom';
import { IconLoader } from 'common/IconLoader';
import classnames from 'classnames';
import { SCREEN_INDEXES, CLOSE_MODAL_SECONDS } from '../utils';
import './CommissionSuccessScreen.css';

const CommissionSuccessScreen = (props) => {
  const onDone = () => {
    props.onNext(SCREEN_INDEXES.SUCCESS, null);
    props.actionsPageThis && props.actionsPageThis.setState({ refreshActionList: true });
    props.clearTimeoutAndInterval();
    props.onClose(SCREEN_INDEXES.SUCCESS);
  };

  return (
    <div className="CommissionSuccessScreen_Container">
      <div className="CommissionSuccessScreen_SuccessMessage_Container">
        <div className="CommissionSuccessScreen_Title_Container">
          <img
            className="CommissionSuccessScreen_Title_Icon"
            src={IconLoader.icon_commission_success}
            alt={'Your Pivot is on the air'}
          />
          <span className="CommissionSuccessScreen_Title_Text">Setup is complete</span>
        </div>
        <div className="CommissionSuccessScreen_Description_Container">
          <span className="CommissionSuccessScreen_Description_One">
            Final adjustments are being made. Please visit{' '}
            <Link className="CommissionSuccessScreen_ActionsLink" to={'/console/actions'} onClick={() => onDone()}>
              Actions
            </Link>
          </span>
          <span className="CommissionSuccessScreen_Description_Two">page for the status update.</span>
          <span className="CommissionSuccessScreen_Countdown_Timer">
            This window will close automatically in
            <span className="CommissionSuccessScreen_Countdown_Timer_Seconds">
              &nbsp;{CLOSE_MODAL_SECONDS - props.timeCount}&nbsp;
            </span>
            seconds.
          </span>
        </div>
      </div>
      <div className={'CommissionSuccessScreen_BottomContainer'}>
        <button
          type="submit"
          className={classnames({
            CommissionSuccessScreen_DoneButton: true
            // CommissionSuccessScreen_DoneButton_Disabled: nameInputError !== '' || deviceIdsValid()
          })}
          onClick={() => onDone()}
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default CommissionSuccessScreen;
